// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"bd19fb38","151":"b3e34c0d","315":"8771b4da","658":"f7f57ebd","998":"6f6a189f"}[chunkId] + ".chunk.css";
};